module.exports = __webpack_public_path__ + "img/bob.194ebdec.jpg";